import type { Opportunity } from '../pages/CampaignDetail/opportunity';

// FNV-1a hash → stable numericId per opportunity id.
// Format varies by type (matching the list column in CampaignCatalog):
//   UPSIZE           → 9 digits
//   AD_SALES         → 4 digits
//   STANDALONE_OFFER → 6 digits
// Both the catalog list and the detail page read through this so the
// displayed ID is identical in both places.
const HASH_SEED = 2166136261;
const FNV_PRIME = 16777619;

const fnv1a = (s: string): number => {
  let h = HASH_SEED;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, FNV_PRIME);
  }
  return h >>> 0;
};

export const numericIdFor = (opp: Pick<Opportunity, 'id' | 'type'>): string => {
  const hash = fnv1a(opp.id);
  switch (opp.type) {
    case 'UPSIZE':
      return String(100000000 + (hash % 900000000));
    case 'AD_SALES':
      return String(1000 + (hash % 9000));
    case 'STANDALONE_OFFER':
      return String(100000 + (hash % 900000));
    default:
      return String(hash);
  }
};
